import React, { useState, useEffect, useMemo } from 'react'
import { getUnMappedProductDetailsBycommId, SaveUpdatecommunityToProduct } from '../../CommunityActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import PopUp from '../../../../../../presentationals/Popup/Popup.component'
export default function Mapped({ communityId }) {
    const [TableData, setTableData] = useState([])
    const [loader, setloader] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: '' })
    const [searchValue,setSearchValue] =useState("")
    useEffect(() => {
        getUnMappedProductDetailsBycommIdFunction()
    }, [])

    const getUnMappedProductDetailsBycommIdFunction = () => {
        setloader(true)
        getUnMappedProductDetailsBycommId(communityId, (callback) => {
            console.log("call", callback)
            setloader(false)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setTableData(callback?.data)
            } else {
                setTableData([])
            }
        })
    }

    // const paginationHandler = (type, showType) => {
    //     const data = showType === "Product" ? totalPagesALlSection?.ProductSection : showType === "E-Nach" ? totalPagesALlSection?.enachSection : showType === "E-Sign" ? totalPagesALlSection?.esignSection : showType === "Charges" ? totalPagesALlSection?.chargesSection : 0
    //     if (type == 'left') {
    //         if (pageValues.count > 1) {

    //             setPageValues(prevState => {
    //                 const newState = {
    //                     ...prevState,
    //                     count: prevState.count - 1,
    //                     total: data,
    //                     buttonDisable: false
    //                 };
    //                 ApicallActiveSection(showType, (pageValues?.count - 1));
    //                 return newState;
    //             });

    //         } else {
    //             setPageValues(prevState => {
    //                 const newState = {
    //                     ...prevState,
    //                     count: prevState.count,
    //                     total: data,
    //                     buttonDisable: false
    //                 };

    //                 return newState;
    //             });
    //         }
    //     }
    //     if (type == 'right') {
    //         if (data >= 10 && pageValues?.count < Math.ceil(data / itemPerPage)) {
    //             setPageValues(prevState => {
    //                 const newState = {
    //                     ...prevState,
    //                     count: prevState.count + 1,
    //                     total: data,
    //                     buttonDisable: false
    //                 };
    //                 ApicallActiveSection(showType, (pageValues?.count + 1));
    //                 return newState;
    //             });
    //         } else {

    //             setPageValues(prevState => {
    //                 const newState = {
    //                     ...prevState,
    //                     count: prevState.count,
    //                     total: data,
    //                     buttonDisable: true
    //                 };

    //                 return newState;
    //             });
    //         }
    //     }
    // }

    const handleToggle = (id) => {
        const data = {
            "productId": id,
            "communityId": communityId
        }
        setloader(true)
        SaveUpdatecommunityToProduct(data, (callback) => {
            setloader(false)
            console.log("call", callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                setpopup({ show: true, popupStatus: "Product Mapped Successfully" })
                getUnMappedProductDetailsBycommIdFunction()
            } else {
                setpopup({ show: true, popupStatus: "Failure" })
            }
            removePopup()
        })
    }
    const closePopup = () => {
        setpopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

     const filteredData = useMemo(() => {
            if (!searchValue) return TableData
            return TableData.filter((item) =>
                item?.productName?.toLowerCase().includes(searchValue.toLowerCase())
            )
        }, [TableData, searchValue])
    

    return (
        <>
            {
                loader ? <Loader /> : ''
            }

            {
                popup.show == true ? <PopUp popupStatus={popup.popupStatus} closePopup={closePopup} /> : ''
            }
            <div className="row" style={{margin:'20px -15px'}}>
            <div className="col-sm-2 col-xs-12">
                <label><i className='fa fa-search'></i>&nbsp; Search</label>
                <input className='form-control' type='text' placeholder='Search By Product Name ...' value={searchValue} onChange={(e)=>setSearchValue(e.target.value)}/>
            </div>
        </div>

            {filteredData && filteredData?.length > 0 ?
                <div style={{ marginTop: '30px' }}>
                    <div className='overflow-auto'>
                        <table className='phocket-table'>
                            <thead style={{ backgroundColor: '#182D64' }}>
                                <tr>
                                    {/* <th>Product Id</th> */}
                                    <th>Product Name</th>
                                    <th>EMI</th>
                                    <th>Min Amount</th>
                                    <th>Max Amount</th>
                                    <th>Processing Fee Type</th>
                                    <th>Processing Fee </th>
                                    <th>Tenure </th>
                                    <th>EMI Type </th>
                                    <th>Product Mapped </th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.map((nbfc, i) => {
                                    return (
                                        <>

                                            <tr key={i}>
                                                {/* <td>{nbfc?.productId || "-"}</td> */}
                                                <td>{nbfc?.productName || "-"}</td>
                                                <td>{nbfc?.emi || "-"}</td>
                                                <td>{nbfc?.minAmount || "-"}</td>
                                                <td>{nbfc?.maxAmount || "-"}</td>
                                                <td>{nbfc?.processingFeeType || "-"}</td>
                                                <td>{nbfc?.processingFee || "-"}</td>
                                                <td>{nbfc?.tenure || "-"}</td>
                                                <td>{nbfc?.emiType || "-"}</td>
                                                <td>
                                                    <div className="togglableSwitch">
                                                        <label class="toggle-switch">
                                                            <input type="checkbox"
                                                                checked={false}
                                                                onChange={() => handleToggle(nbfc.productId)}
                                                            />
                                                            <div class="toggle-switch-background">
                                                                <div class="toggle-switch-handle"></div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>

                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left', productDetail)}><span className="fa fa-chevron-left" /></button></div>
                            <div className="col-sm-2 col-xs-12  phoc text-center" >Total: {TableData?.length}&nbsp; of &nbsp; {pageValues?.total}</div>
                            <div className="col-sm-5 col-xs-12 no-padding"> <button type="button" disabled={pageValues?.buttonDisable} className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right', productDetail)}><span className="fa fa-chevron-right" /></button></div> </div>
                    </div> */}
                </div>
                : ''}
        </>
    )
}
